export default class Integration {
    constructor(integration, locale, currency) {
        this.integration = integration
        this.locale = locale
        this.currency = currency
    }

    translate(label) {
        try {
            return label.locales[this.locale]
        } catch(err) {
            return false
        }
    }

    products() {
        let products = [
            {
                id: this.integration.product_id,
                qty: "1",
                group: "Integration",
                name: this.translate(this.integration.label),
                price: this.integration.price
            }
        ]

        return products
    }

    prepareForCheckoutLink() {
        let body =  {
            products: this.products(),
            short_form: "1",
            trial_period: this.integration.trial_period
        };

        return body
    }

    priceInCurrency() {
        if (this.integration.price === null) {
            return 0
        }
        
        let c = this.currency || "usd"

        return this.products().reduce((prev, next) => {
            return prev + next.price[c]
        }, 0)
    }
}